export enum OrderAddRequestSequenceOrder {
  ANY = "ANY",
  STRICT = "STRICT",
}

export type OrderAddRequestRideWaypointMetaCargoItem = {
  id: string;
};

export type OrderAddRequestRideWaypointMetaCargoItems = {
  subjects: OrderAddRequestRideWaypointMetaCargoItem[];
};

export type OrderAddRequestRideWaypointMeta = {
  id: string;
  cargoEnter: OrderAddRequestRideWaypointMetaCargoItems;
  cargoExit: OrderAddRequestRideWaypointMetaCargoItems;
};

export type OrderAddRequestRideWaypoint = {
  lat: number;
  lon: number;
  time?: string;
  haltingTime: number;
  displayName: string;
  meta: OrderAddRequestRideWaypointMeta;
};

export type OrderAddRequestRideWaypointGroup = {
  seq: OrderAddRequestRideWaypoint[];
  sequenceOrder: OrderAddRequestSequenceOrder;
};

export type OrderAddRequestRideSeqItem =
  | OrderAddRequestRideWaypoint
  | OrderAddRequestRideWaypointGroup;

export type OrderAddRequestCargoOrderRide = {
  seq: OrderAddRequestRideSeqItem[];
  sequenceOrder: OrderAddRequestSequenceOrder;
};

export type OrderAddBody = {
  railyRide: OrderAddRequestCargoOrderRide;
  targetTaxiId: string | null;
  externalId: string | null;
  cargoTaxiContractId: string | null;
};

export type OrderAddQueryParams = {
  assumeDispatcherId?: string;
};

type OrderAddRequest = {
  railyRide: OrderAddRequestCargoOrderRide;
  targetTaxiId: string | null;
  externalId: string | null;
  cargoTaxiContractId: string | null;
  assumeDispatcherId?: string;
};

export default OrderAddRequest;
